import { Storage } from "src/itsf/utils/storage";
import { ICart } from "@features/cart/ICart";

const STORAGE = "eir-eshop";
const storage = () => new Storage(sessionStorage);

export const saveUserInformation = (orderReference: string, prospectId: string) => {
    saveStorage({ orderReference, prospectId });
};

export const saveCart = (cart: ICart) => {
    saveStorage({ cart });
};

export const saveAnonymous = (isAnonymous: boolean) => {
    saveStorage({ isAnonymous });
};

export const saveLinkedUser = () => {
    saveStorage({ isLinked: true });
};

const saveStorage = <T>(dataToStore: T) => {
    const newStorage = Object.assign(loadStorage() as any, dataToStore);
    storage().save(STORAGE, newStorage);
};

export const clearStorage = () => {
    storage().clear();
};

export const loadStorage = <T>(): T => storage().load(STORAGE);

export const getProspectId = () => loadStorage<{ prospectId: string }>().prospectId;

export const getCart = () => loadStorage<{ cart: ICart }>().cart;

export const getIsAnonymous = () => loadStorage<{ isAnonymous: boolean }>().isAnonymous;

export const getIsUserLinked = () => loadStorage<{ isLinked: boolean }>().isLinked;

export interface IStorage {
    cart?: ICart;
    isLinked: boolean;
    orderReference?: string;
    prospectId?: string;
    isAnonymous?: boolean;
}
